import { type FC } from "react";
import { Root } from "./styled";

export const AppLoading: FC = () => {
  return <Root>Загрузка...</Root>;
};
